export const CodeVerifier = {
  get: (state: string): string | null => {
    return localStorage.getItem(`codeVerifier-${state}`)
  },
  set: (state: string, code_verifier: string | null) => {
    if (code_verifier) {
      localStorage.setItem(`codeVerifier-${state}`, code_verifier)
    } else {
      localStorage.removeItem(`codeVerifier-${state}`)
    }
  },
}
